/* eslint-disable camelcase */
import React from 'react';
import looppa from 'looppa';
import PropTypes from 'prop-types';
import Slider from 'components/slider';
import ProductSpecs from 'components/product-specs';
import ProductInfoCard from 'components/product-info-card';
import BuyBox from 'components/buy-box';
import BrandsList from 'components/brands-list';
import { productImage } from 'util/react/stack-images-path';
import imageAttrs from 'util/react/image-attributes';
import sliderConfig from './slider-config';
import { DETAIL } from 'constants/api-images-types';

function renderDetailsPanel(product) {
    return (
        <section className="product-details-panel">
            <ProductInfoCard {...product} />
            { product.regulated_description ? <p className="product-details-content--paragraph">{product.regulated_description}</p> : null }
            <BrandsList brands={product.brands} />
        </section>
    );
}

function renderImage(img, key) {
    return (
        <figure className="product-details-content--image-wrapper" key={key || 0}>
            <img className="product-details-content--image" alt="" { ...imageAttrs(productImage(img, DETAIL)) }/>
        </figure>
    );
}

export default function ProductDetailsContent({ product, facet, mustIncludeDetailsPanel, hasBuyBox }) {
    return (
        <div className={`product-details-content product-details-content__${ facet }`}>
            <div className="product-details-content--inner-content">
                <div className="product-details-content--slider">
                    {product.images.length > 1 ? (
                        <Slider
                            facet="product-detail"
                            config={sliderConfig}
                        >
                            {looppa(product.images)(renderImage)}
                        </Slider>
                    ) : (
                        renderImage(product.image)
                    )}
                </div>
                {mustIncludeDetailsPanel ? null : <p className="product-details-content--paragraph">{product.regulated_description}</p>}
            </div>
            <div className="product-details-content--panel">
                {mustIncludeDetailsPanel ? renderDetailsPanel(product) : null}

                <div className="product-details-content--inner-content">
                    <div className="product-details-content--tabs">
                        <ProductSpecs sections={product.sections} />
                    </div>
                </div>
            </div>
            {mustIncludeDetailsPanel && hasBuyBox ? <BuyBox product={product} facet={facet === 'modal' ? null : 'fixed'} /> : null}
        </div>
    );
}

ProductDetailsContent.propTypes = {
    product: PropTypes.object.isRequired,
    facet: PropTypes.string,
    mustIncludeDetailsPanel: PropTypes.bool.isRequired,
    hasBuyBox: PropTypes.bool.isRequired,
};

ProductDetailsContent.defaultProps = {
    facet: 'base',
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/product-details-content/index.js